import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="comprar" className="bg-black py-24 px-4 relative overflow-hidden scroll-mt-10" data-id="element-171">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[500px] bg-[#D4AF37] opacity-10 blur-[120px] rounded-full pointer-events-none" data-id="element-172"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-173">
        <div className="text-center mb-12" data-id="element-174">
          <h2 className="text-4xl md:text-6xl font-black text-white uppercase tracking-tight mb-6" data-id="element-175">
            Tu momento de empezar es{' '}
            <span className="text-[#D4AF37]" data-id="element-176">AHORA</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto font-medium" data-id="element-177">
            Los cursos presenciales de detailing profesional suelen costar
            cientos de dólares y requieren semanas de tu tiempo.
          </p>
        </div>

        <div className="bg-[#132847] rounded-3xl shadow-2xl overflow-hidden border-4 border-[#D4AF37] transform transition-all hover:scale-[1.01] duration-300" data-id="element-178">
          <div className="bg-gradient-to-r from-gray-900 to-black p-6 text-center border-b border-gray-800" data-id="element-179">
            <h3 className="text-2xl font-black text-white uppercase tracking-widest" data-id="element-180">
              MEGA PACK COMPLETO
            </h3>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-181">
            <div className="mb-8" data-id="element-182">
              <p className="text-gray-400 font-bold uppercase tracking-wider mb-2" data-id="element-183">
                Valor Normal: <span className="line-through" data-id="element-184">$150.000 ARS</span>
              </p>
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-185">
                <span className="text-2xl font-bold text-gray-300" data-id="element-186">$</span>
                <span className="text-6xl md:text-8xl font-black text-white tracking-tighter" data-id="element-187">
                  30.000
                </span>
              </div>
              <p className="text-gray-400 font-medium" data-id="element-188">
                Pesos Argentinos (Pago Único)
              </p>
            </div>

            <div className="bg-[#0A1628] rounded-xl p-6 mb-8 text-left border border-[#1E3A5F]" data-id="element-189">
              <h4 className="font-black text-white mb-4 uppercase" data-id="element-190">
                Resumen de lo que te llevas hoy:
              </h4>
              <ul className="space-y-3" data-id="element-191">
                <li className="flex items-center gap-2 text-gray-300 font-medium" data-id="element-192">
                  <ShieldCheck className="w-5 h-5 text-[#D4AF37]" data-id="element-193" /> 5 Tomos del
                  Método Detailing Pro
                </li>
                <li className="flex items-center gap-2 text-gray-300 font-medium" data-id="element-194">
                  <ShieldCheck className="w-5 h-5 text-[#D4AF37]" data-id="element-195" /> BONO 1: Kit
                  de Productos
                </li>
                <li className="flex items-center gap-2 text-gray-300 font-medium" data-id="element-196">
                  <ShieldCheck className="w-5 h-5 text-[#D4AF37]" data-id="element-197" /> BONO 2:
                  Guía 10 Primeros Clientes
                </li>
                <li className="flex items-center gap-2 text-gray-300 font-medium" data-id="element-198">
                  <ShieldCheck className="w-5 h-5 text-[#D4AF37]" data-id="element-199" /> BONO 3:
                  Guía de Precios
                </li>
                <li className="flex items-center gap-2 text-gray-300 font-medium" data-id="element-200">
                  <ShieldCheck className="w-5 h-5 text-[#D4AF37]" data-id="element-201" /> Acceso de
                  por vida
                </li>
              </ul>
            </div>

            <CTAButton text="QUIERO ACCEDER AL MÉTODO DETAILING PRO" className="w-full text-xl md:text-2xl py-6 md:py-8 mb-6 shadow-[0_10px_40px_rgba(212,175,55,0.4)]" data-id="element-202" />

            <div className="flex flex-col items-center justify-center gap-4 text-gray-400 text-sm font-medium" data-id="element-203">
              <div className="flex items-center gap-2" data-id="element-204">
                <Lock className="w-4 h-4" data-id="element-205" /> Pago 100% Seguro y Encriptado
              </div>
              <div className="flex items-center gap-4 opacity-60" data-id="element-206">
                <CreditCard className="w-8 h-8" data-id="element-207" />
                <span className="font-bold" data-id="element-208">
                  MERCADO PAGO • TARJETAS • EFECTIVO
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}